/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
import PropTypes from 'prop-types';
import { quantizeColorScalesKeys } from '../lib/colors';

export var quantizeColorScalePropType = PropTypes.oneOfType([PropTypes.oneOf(quantizeColorScalesKeys), PropTypes.func, PropTypes.arrayOf(PropTypes.string)]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nivo/core/es/props/colors.js
// module id = 1428
// module chunks = 0